import { Layout } from "@stripe/stripe-js";

/**
 * Shared Stripe configuration constants used across portals.
 */

/**
 * Font configuration for Stripe Elements.
 * Loads IBM Plex Sans to match Cascadia design system.
 */
export const fonts = [
  {
    cssSrc:
      "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap",
  },
];

/**
 * Default Stripe Element options.
 * Uses tabs layout for payment method selection.
 */
export const options = {
  layout: "tabs" as Layout,
};
